import z from 'zod'
import { nullSafeOptionalString } from '../shared/schema'

export const schema = z.object({
  breakoutAppUrl: nullSafeOptionalString(),
})

export const empty = Object.freeze(
  schema.parse({
    breakoutAppUrl: undefined,
  })
)

export type FirestoreSettingsLti = z.infer<typeof schema>
